import { STATIC_ASSETS_PATH, FULFILLMENT_METHOD_STH, FULFILLMENT_METHOD_BOPIS } from './product-add-on-constants';

export const buildImageURL = (imageName) => `${STATIC_ASSETS_PATH}${imageName}`;

const displayInstallationSku = ({ isInstallationSku, availableFulfillments }) => {
  return (isInstallationSku && availableFulfillments.includes(FULFILLMENT_METHOD_STH));
};
const displayInStoreAssembly = ({ inStoreAssemblyAvailable, availableFulfillments }) => {
  return (inStoreAssemblyAvailable && availableFulfillments.includes(FULFILLMENT_METHOD_BOPIS));
};

export const displayAttachLabor = ({
  isInstallationSku,
  inStoreAssemblyAvailable,
  availableFulfillments,
  currentFulfillment
}) => {
  return (
    currentFulfillment && (
      displayInstallationSku({ isInstallationSku, availableFulfillments })
      || displayInStoreAssembly({ inStoreAssemblyAvailable, availableFulfillments })
    )
  );
};